import { useState, useEffect } from 'react';
import * as yup from 'yup';
import { axiosInstance } from '../../../../api/axios';
import APIEndpoints from '../../../api/APIEndpoints';
import { HttpSuccessCodes } from '../../../errorhandling/HttpErrorCodes';

const usePasswordSettings = (setting) => {
  const isOTPSetting = setting === 'otpSetting' ? true : false;

  const fields = {
    allowUnlockDisabledLogin: '',
    passwordMinLength: '',
    passwordMaxLength: '',
    invalidAttempts: '',
    numberOfUpperCase: '',
    numberOfNumerics: '',
    numberOfSpecialCharacters: '',
  };
  const OTPFields = {
    TwoFARequired: '',
    OTPExpiresIn: '',
    InvalidOTPAttempts: '',
    OTPLength: '',
    FrequencyForTrustedDevice: '',
    FrequencyTypeForTrustedDevice: '',
  };

  const [formValues, setFormValues] = useState(fields);
  const [updatedFormValues, setUpdatedFormValues] = useState(fields);
  const [OTPformValues, setOTPFormValues] = useState(OTPFields);
  const [updatedOTPFormValues, setUpdatedOTPFormValues] = useState(OTPFields);
  const [loader, setLoader] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [enableOTP, setEnableOTP] = useState(false);

  //yup validation
  const maxPasswordLength = updatedFormValues.passwordMinLength + 1;
  const schema = yup.object({
    passwordMinLength: yup
      .number('Please enter valid input !')
      .required('Number of minimum characters are required!')
      .min(12, 'Minimum characters required are 12')
      .max(999, ''),

    passwordMaxLength: yup
      .number('Please enter valid input !')
      .required('Number of maximum characters are required!')
      .min(
        maxPasswordLength,
        'Maximum characters required should be greater than minimum characters',
      )
      .max(999, ''),

    invalidAttempts: yup
      .string()
      .required('Number of invalid attempts are required!')
      .matches(/^[0-9]*$/, 'Please enter valid input !'),
  });

  const OTPschema = yup.object({
    OTPExpiresIn: yup
      .string()
      .required('Duration for OTP validation is required!')
      .matches(/^[0-9]*$/, 'Please enter valid input !'),
    InvalidOTPAttempts: yup
      .string()
      .required('Maximum number of invalid attempts are required!')
      .matches(/^[0-9]*$/, 'Please enter valid input !'),
    OTPLength: yup
      .string()
      .required('OTP Length is required!')
      .matches(/^[0-9]*$/, 'Please enter valid input !'),
    FrequencyForTrustedDevice: yup
      .string()
      .required('Interval for each OTP is required!')
      .matches(/^[0-9]*$/, 'Please enter valid input !'),
  });

  const getPasswordConfiguration = async () => {
    setSkeletonLoader(true);
    const responseConfiguration = await axiosInstance.get(
      APIEndpoints.getAdminConfigResources(),
    );
    const adminConfig = responseConfiguration.data;

    const UpdatedFields = {
      OID: adminConfig?.Response?.PasswordRules?.OID,
      allowUnlockDisabledLogin:
        adminConfig?.Response?.PasswordRules?.AllowUnlockDisabledLogin ===
        'true'
          ? 1
          : 0,
      passwordMinLength:
        adminConfig?.Response?.PasswordRules?.PasswordMinLength,
      passwordMaxLength:
        adminConfig?.Response?.PasswordRules?.PasswordMaxLength,
      invalidAttempts:
        adminConfig?.Response?.PasswordRules?.NoOfInvalidAttempts,
      numberOfUpperCase:
        adminConfig?.Response?.PasswordRules?.NoOfUpperCaseReqd,
      numberOfNumerics: adminConfig?.Response?.PasswordRules?.NoOfNumericsReqd,
      numberOfSpecialCharacters:
        adminConfig?.Response?.PasswordRules?.NoOfSpecialCharactersReqd,
    };
    const OTPUpdatedFields = {
      oid: adminConfig?.Response?.InsurerClientSettings?.oid,
      TwoFARequired:
        adminConfig?.Response?.InsurerClientSettings?.TwoFARequired === 'true'
          ? 1
          : 0,
      OTPExpiresIn: adminConfig?.Response?.InsurerClientSettings?.OTPExpiresIn,
      InvalidOTPAttempts:
        adminConfig?.Response?.InsurerClientSettings?.InvalidOTPAttempts,
      OTPLength: adminConfig?.Response?.InsurerClientSettings?.OTPLength,
      FrequencyForTrustedDevice:
        adminConfig?.Response?.InsurerClientSettings?.FrequencyForTrustedDevice,
      FrequencyTypeForTrustedDevice:
        adminConfig?.Response?.InsurerClientSettings
          ?.FrequencyTypeForTrustedDevice,

      //Dependent fields in insuranceClientSettings
      //TODO: Need to separate out the OTP settings fields in Backend
      AllowMembersToRegister:
        adminConfig?.Response?.InsurerClientSettings?.AllowMembersToRegister,
      DefaultMemberRole:
        adminConfig?.Response?.InsurerClientSettings?.DefaultMemberRole,
      AllowDependentsToRegister:
        adminConfig?.Response?.InsurerClientSettings?.AllowDependentsToRegister,
      DefaultDependentRole:
        adminConfig?.Response?.InsurerClientSettings?.DefaultDependentRole,
      DependentRegistrationAgeLimit:
        adminConfig?.Response?.InsurerClientSettings
          ?.DependentRegistrationAgeLimit,
      MemberRegistrationRequiredMemberID:
        adminConfig?.Response?.InsurerClientSettings
          ?.MemberRegistrationRequiredMemberID,
      MemberRegistrationRequiredFindMyAccount:
        adminConfig?.Response?.InsurerClientSettings
          ?.MemberRegistrationRequiredFindMyAccount,
      DependentRegistrationRequiredMemberID:
        adminConfig?.Response?.InsurerClientSettings
          ?.DependentRegistrationRequiredMemberID,
      DependentRegistrationRequiredFindMyAccount:
        adminConfig?.Response?.InsurerClientSettings
          ?.DependentRegistrationRequiredFindMyAccount,
      FirstTimeRegistration:
        adminConfig?.Response?.InsurerClientSettings?.FirstTimeRegistration,
      Login: adminConfig?.Response?.InsurerClientSettings?.Login,
      FrequencyForTwoFA:
        adminConfig?.Response?.InsurerClientSettings?.FrequencyForTwoFA,
      AllowSetTrustedDevice:
        adminConfig?.Response?.InsurerClientSettings?.AllowSetTrustedDevice,
    };
    setFormValues(UpdatedFields);
    setUpdatedFormValues(UpdatedFields);
    setOTPFormValues(OTPUpdatedFields);
    setUpdatedOTPFormValues(OTPUpdatedFields);
    setEnableOTP(
      adminConfig?.Response?.InsurerClientSettings?.TwoFARequired === 'true'
        ? 1
        : 0,
    );
    setSkeletonLoader(false);
  };

  const handleCheckBox = (e) => {
    console.log(e.currentTarget.checked);
    isOTPSetting
      ? setUpdatedOTPFormValues({
          ...updatedOTPFormValues,
          [e.currentTarget.name]:
            e.currentTarget.name === 'TwoFARequired'
              ? e.currentTarget.checked === true
                ? 1
                : 0
              : e.currentTarget.checked === true
              ? 1
              : 0,
        })
      : setUpdatedFormValues({
          ...updatedFormValues,
          [e.currentTarget.name]:
            e.currentTarget.name === 'allowUnlockDisabledLogin'
              ? e.currentTarget.checked === true
                ? 1
                : 0
              : e.currentTarget.checked === true
              ? 1
              : 0,
        });

    if (e.currentTarget.name === 'TwoFARequired') {
      setEnableOTP(e.currentTarget.checked === true ? 1 : 0);
    }
  };

  const handleInput = (e, setFieldValue, handleChange) => {
    handleChange(e);
    isOTPSetting
      ? setUpdatedOTPFormValues({
          ...updatedOTPFormValues,
          [e.currentTarget.name]:
            e.currentTarget.value.trim() !== ''
              ? parseInt(e.currentTarget.value.trim())
              : '',
        })
      : setUpdatedFormValues({
          ...updatedFormValues,
          [e.currentTarget.name]:
            e.currentTarget.value.trim() !== ''
              ? parseInt(e.currentTarget.value.trim())
              : '',
        });

    const trimmedValue =
      e.currentTarget.value !== ''
        ? parseInt(e.currentTarget.value.trim())
        : '';
    setFieldValue(e.currentTarget.name, trimmedValue);
  };

  const handleSelect = (e, fieldName) => {
    setUpdatedOTPFormValues({
      ...updatedOTPFormValues,
      [fieldName]: e.value,
    });
  };

  const savePasswordSettings = async () => {
    console.log('updatedOTPFormValues', updatedOTPFormValues);
    try {
      setLoader(true);
      const payload = {
        PasswordRules: {
          OID: updatedFormValues.OID,
          PasswordMinLength: updatedFormValues.passwordMinLength,
          PasswordMaxLength: updatedFormValues.passwordMaxLength,
          NoOfUpperCaseReqd: updatedFormValues.numberOfUpperCase,
          NoOfNumericsReqd: updatedFormValues.numberOfNumerics,
          NoOfSpecialCharactersReqd:
            updatedFormValues.numberOfSpecialCharacters,
          NoOfInvalidAttempts: updatedFormValues.invalidAttempts,
          AllowUnlockDisabledLogin:
            updatedFormValues.allowUnlockDisabledLogin === 1 ? 'true' : 'false',
        },
      };
      const OTPPayload = {
        InsurerClientSettings: {
          oid: updatedOTPFormValues.oid,
          TwoFARequired:
            updatedOTPFormValues.TwoFARequired === 1 ? 'true' : 'false',
          FrequencyForTrustedDevice:
            updatedOTPFormValues.FrequencyForTrustedDevice,
          FrequencyTypeForTrustedDevice:
            updatedOTPFormValues.FrequencyTypeForTrustedDevice,
          InvalidOTPAttempts: updatedOTPFormValues.InvalidOTPAttempts,
          OTPExpiresIn: updatedOTPFormValues.OTPExpiresIn,
          OTPLength: updatedOTPFormValues.OTPLength,
          //Dependent fields in insuranceClientSettings
          //TODO: Need to separate out the OTP settings fields in Backend
          AllowMembersToRegister: updatedOTPFormValues.AllowMembersToRegister,
          DefaultMemberRole: updatedOTPFormValues.DefaultMemberRole,
          AllowDependentsToRegister:
            updatedOTPFormValues.AllowDependentsToRegister,
          DefaultDependentRole: updatedOTPFormValues.DefaultDependentRole,
          DependentRegistrationAgeLimit:
            updatedOTPFormValues.DependentRegistrationAgeLimit,
          MemberRegistrationRequiredMemberID:
            updatedOTPFormValues.MemberRegistrationRequiredMemberID,
          MemberRegistrationRequiredFindMyAccount:
            updatedOTPFormValues.MemberRegistrationRequiredFindMyAccount,
          DependentRegistrationRequiredMemberID:
            updatedOTPFormValues.DependentRegistrationRequiredMemberID,
          DependentRegistrationRequiredFindMyAccount:
            updatedOTPFormValues.DependentRegistrationRequiredFindMyAccount,
          FirstTimeRegistration: updatedOTPFormValues.FirstTimeRegistration,
          Login: updatedOTPFormValues.Login,
          FrequencyForTwoFA: updatedOTPFormValues.FrequencyForTwoFA,
          AllowSetTrustedDevice: updatedOTPFormValues.AllowSetTrustedDevice,
        },
      };
      const response = await axiosInstance.put(
        APIEndpoints.putAdminConfigResources(),
        isOTPSetting ? OTPPayload : payload,
      );

      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        setLoader(false);
        return new Promise((resolve, reject) => {
          resolve('success');
        });
      } else {
        setLoader(false);
        return new Promise((resolve, reject) => {
          reject('Failed');
        });
      }
    } catch (e) {
      setLoader(false);
      return new Promise((resolve, reject) => {
        reject('Failed');
      });
    }
  };

  useEffect(() => {
    getPasswordConfiguration();
  }, []);

  return {
    schema,
    OTPschema,
    formValues,
    OTPformValues,
    updatedFormValues,
    updatedOTPFormValues,
    loader,
    skeletonLoader,
    enableOTP,
    handleCheckBox,
    handleInput,
    handleSelect,
    savePasswordSettings,
  };
};

export default usePasswordSettings;
